// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1SlG1","header":"PatientBlock_header__wvMCk","label":"PatientBlock_label__1jTt2","option":"PatientBlock_option__ylgMc"};